<template>
  <div class="p-index">
    <div class="head">
      <div class="inner">
        <img height="30" src="/image/logo.png" />
        <div class="links">
          <router-link to="/home">
            <label for="">首页</label>
          </router-link>
          <router-link to="/product">
            <label for="product">产品介绍</label>
          </router-link>
          <router-link to="/solution">
            <label for="solution">解决方案</label>
          </router-link>
          <router-link to="/contact">
            <label for="">联系我们</label>
          </router-link>
        </div>
        <a class="login">
          <label for="login">
            <img width="18" height="18" src="/image/user.png" />
            <span>登录</span>
          </label>
        </a>
      </div>
    </div>
    <div class="menu">
      <button id="product" class="links">
        <div class="inner">
          <router-link to="/product/organization">机构版</router-link>
          <router-link to="/product/personal">个人版</router-link>
        </div>
      </button>
      <button id="solution" class="links">
        <div class="inner">
          <router-link to="/solution/weight">一站式体重管理解决方案</router-link>
          <router-link to="/solution/community">社区营养与健康管理解决方案</router-link>
        </div>
      </button>
      <button id="login" class="links">
        <div class="inner">
          <a href="http://passport.shanshi.net.cn/login" target="_blank">机构版登录</a>
          <a href="http://passport.shanshi.net.cn/login/personal" target="_blank">个人版登录</a>
        </div>
      </button>
    </div>
    <router-view class="body" />
    <div class="foot">
      <div class="inner">
        <div class="links">
          <div class="contact">
            <img width="40" height="40" src="/image/cs.png" />
            <div class="hotline">
              <div class="label">联系电话</div>
              <div class="tel">400-995-9495</div>
            </div>
          </div>
          <router-link to="/home">首页</router-link>
          <span>|</span>
          <router-link to="/product">产品介绍</router-link>
          <span>|</span>
          <router-link to="/solution">解决方案</router-link>
          <span>|</span>
          <router-link to="/contact">联系我们</router-link>
        </div>
        <div class="links">
          <router-link to="/solution">解决方案</router-link>
          <span></span>
          <router-link to="/solution/weight">一站式体重管理解决方案</router-link>
          <span></span>
          <router-link to="/solution/community">社区营养与健康管理解决方案</router-link>
        </div>
        <div class="copyright">
          <span>Copyright © 2016-{{ new Date().getFullYear() }} 南京善识健康科技有限公司 版权所有</span>
          <a href="https://beian.miit.gov.cn" target="_blank">苏ICP备14048097号</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menu: [],
    };
  },
  async created() { },
};
</script>

<style lang="less">
.p-index {
  flex: 1;
  display: flex;
  flex-direction: column;

  >.head {
    top: 0px;
    left: 0px;
    right: 0px;
    z-index: 3;
    position: fixed;
    background-color: #ffffff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

    >.inner {
      width: 1010px;
      display: flex;
      margin: 0px auto;
      padding: 15px 0px;
      align-items: center;
      justify-content: space-between;

      >.links {
        width: 500px;

        >a {
          font-size: 15px;
          position: relative;
          display: inline-block;

          &::after {
            left: 50%;
            width: 100%;
            height: 3px;
            content: "";
            display: block;
            margin: 0px auto;
            position: absolute;
            text-align: center;
            border-radius: 1.5px;
            transform: translate3d(-50%, 10px, 0);
            transition: 200ms;
          }

          &:hover {
            &::after {
              background-color: #40d1a8;
            }
          }

          &.router-link-active {
            color: #40d1a8;

            &::after {
              background-color: #40d1a8;
            }
          }

          >label {
            cursor: pointer;
            padding: 23px 10px;
          }
        }
      }

      >.login {
        >label {
          cursor: pointer;
          padding: 23px 0px;

          &:hover {
            >span {
              color: #40d1a8;
            }
          }

          >img {
            vertical-align: middle;
          }

          >span {
            color: #666666;
            line-height: 18px;
            vertical-align: middle;
            transition: 200ms;
          }
        }
      }
    }
  }

  >.menu {
    >.links {
      top: 60px;
      left: 0px;
      right: 0px;
      z-index: 1;
      width: 100%;
      height: 80px;
      border: none;
      outline: none;
      display: flex;
      padding: 10px;
      position: fixed;
      min-width: 1010px;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      border-bottom: 1px solid #eeeeee;
      transform: translate3d(0, -80px, 0);
      transition: 200ms;
      transition-delay: 100ms;

      &:hover {
        z-index: 2;
        transform: translate3d(0, 0, 0);
        transition-delay: 100ms;
      }

      &#product {
        >.inner {
          transform: translate3d(-129px, 0, 0);
        }
      }

      &#solution {
        >.inner {
          transform: translate3d(-30px, 0, 0);
        }
      }

      &#login {
        >.inner {
          transform: translate3d(480px, 0, 0);
        }
      }

      >.inner {
        >a {
          margin: 1px;
          color: #333333;
          margin: 0px 50px;
          display: inline-block;
          transition: 200ms;

          &:hover {
            color: #3dd2ac;
            text-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
          }

          &.router-link-active {
            color: #3dd2ac;
          }
        }
      }
    }
  }

  >.body {
    flex: 1;
    margin-top: 61px;
  }

  >.foot {
    text-align: center;
    background-color: #262930;

    >.inner {
      width: 1010px;
      color: #999999;
      margin: 0px auto;
      padding: 20px 0px;

      >div {
        padding: 20px 0px;
      }

      >.links {
        position: relative;
        border-bottom: 1px solid #40434a;

        >.contact {
          top: 0px;
          left: 0px;
          display: flex;
          color: #ffffff;
          position: absolute;
          align-items: center;

          >img {
            margin: 10px 10px 10px 0px;
          }

          >.hotline {
            text-align: left;
            line-height: 24px;

            >.tel {
              font-size: 18px;
            }
          }
        }

        >a {
          transition: 200ms;

          &:hover,
          &.router-link-active {
            color: #ffffff;
          }
        }

        >span {
          margin: 0px 20px;
        }
      }

      >.copyright {
        font-size: 12px;
        line-height: 20px;
      }
    }
  }
}</style>